/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext } from "react";
import { TDndDraggableID, TDndID } from "../Dnd/DndTypes";

export interface IDndDraggableContext {
	draggableId: TDndDraggableID;
	dndContextId: TDndID;
	disabled: boolean;
}

export const DndDraggableContext = React.createContext<IDndDraggableContext>(null);

export function useDndDraggableContext(): IDndDraggableContext {
	return useContext(DndDraggableContext);
}
